import { PageDetailContent } from '@client/toolkit';

import { AgreementPartiesCard } from '../components/agreement-parties/agreement-parties-card.component';
import { AgreementNameField } from '../components';
import { PageContentAnimation } from '../../../../components';
import { AgreementWizardActions } from '../components/agreement-wizard-actions.component';

export function AgreementPartiesRoute() {
  return (
    <PageDetailContent>
      <PageContentAnimation className="space-y-4 px-4 pt-2 pb-8 rounded-lg shadow-lg border border-border">
        <div className="flex items-center">
          <AgreementNameField className="flex-1" />
          <AgreementWizardActions />
        </div>
        <AgreementPartiesCard />
      </PageContentAnimation>
    </PageDetailContent>
  );
}
